import { z } from 'zod';

const advertiserSchema = z.object({
  id: z.number(),
  name: z.string(),
  clientId: z.number(),
});

const clientSchema = z.object({
  id: z.number(),
  name: z.string(),
  advertisers: z.array(advertiserSchema),
});

export const clientsResponseSchema = z.object({
  data: z.object({
    clients: z.array(clientSchema),
  }),
});

export type ClientsResponse = z.infer<typeof clientsResponseSchema>;
export type Client = z.infer<typeof clientSchema>;
export type Advertiser = z.infer<typeof advertiserSchema>;
